export default __webpack_public_path__ + "static/media/Okta.a4cb68bb.md";